import { combineReducers } from 'redux'
import merge from 'lodash/merge'

import { RECEIVE_NOTES } from '../actions/note-actions.js'

import { RESET_STORE } from '../actions/currentUser-actions'

const noteList = (state = [], action) => {
  switch(action.type) {
    case RECEIVE_NOTES: return merge([], action.notes)
    case RESET_STORE: return []
    default: return state
  }
}

export default combineReducers( {
  noteList
})
